import globals from "../config/appconfig";
import axios from "axios";

import Utils from "../utils/Utils";

export default class ApmsService {

    static urlGetGruppiPerApplicazione = globals["app-url-backend-apms"] + "/v1/attributi/"
    static urlInserisciUtente = globals["app-url-backend-apms"] + "/v1/utente"
    static urlModificaUtente = globals["app-url-backend-apms"] + "/v1/utente"
    static urlEliminaUtente = globals["app-url-backend-apms"] + "/v1/utente"
    static urlRicercaUtente = globals["app-url-backend-apms"] + "/v2/utenti"

    static getGruppiPerApplicazione() {
       return axios.get(this.urlGetGruppiPerApplicazione + "RAF")
    }

    static inserisciUtente(jsonInsert) {
        return axios.post(this.urlInserisciUtente, jsonInsert)
    }

    static modificaUtente(jsonInsert) {
        return axios.put(this.urlModificaUtente, jsonInsert)
    }

    static ricercaUtenti(params) {
        return axios.get(this.urlRicercaUtente + Utils.addQueryParamsToRequestUrl(params))
    }

    static eliminaUtente(jsonDelete) {
        return axios.delete(this.urlEliminaUtente,{data:jsonDelete})
    }

}